import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import {Button, Grid, Tooltip } from '@mui/material'
import { Form, Formik } from 'formik'
import formModel, { initialValues, validationSchema } from 'utils/formModels/setupEntitySettingModel'
import { useErrorAlert } from 'utils/customHooks/useErrorAlert'
import { useSuccessAlert } from 'utils/customHooks/useSuccessAlert'
import CheckboxField from 'components/atoms/fields/CheckboxField'
import { FaInfoCircle } from 'react-icons/fa'

interface IProps {
  type: string
  entity: any
  enableMutation: any
  disableMutation: any
}

const SetupEntitySettingForm: FC<IProps> = ({
  entity, 
  enableMutation,
  disableMutation
}) => {
  const { t } = useTranslation()

  const [
    enableEntity,
    { isLoading: enableLoading, isSuccess: enableSuccess, error: enableError, data: enableData },
  ] = enableMutation()

  const [
    disableEntity,
    { isLoading: disableLoading, isSuccess: disableSuccess, error:  disableError, data: disableData },
  ] = disableMutation()

  const isLoading = enableLoading || disableLoading
  const error = enableError || disableError
  const success = enableSuccess || disableSuccess

  useErrorAlert(error)
  useSuccessAlert(success ? t('alerts.setup-updated') : '')

  const {
    is_enabled,
  } = formModel()
  
  return (
    <Formik
      enableReinitialize
      initialValues={entity}
      onSubmit={(values: any) => {}}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form>
            <Grid container spacing={4} sx={{ marginTop: '-1rem' }}>
              <Grid item xs={12} md={12}>
                <table><tbody><tr><td>
                    <CheckboxField fieldProps={{...is_enabled, label: entity.title}} onChange={() => {
                        if(values?.is_enabled){
                          disableEntity({id: entity.id, body: {}})
                        }else{
                          enableEntity({id: entity.id, body: {}})
                        }
                    }} />
                  </td>{entity.hint && <td><div style={{ paddingBottom: '0.7rem' }}>
                    <Tooltip title={entity.hint} placement='top'>
                              <Button
                                onClick={() => {}}
                                size='small'
                                color='info'
                                sx={{
                                  minWidth: '0px',
                                  position: 'relative',
                                  top: '-1px'
                                }}
                              ><FaInfoCircle /></Button>
                      </Tooltip>
                  </div></td>}</tr></tbody></table>
              </Grid>
            </Grid>
        </Form>
        )
      }}
    </Formik>
  )
}
export default SetupEntitySettingForm
